import { WORDPRESS_API } from "shared/constants/api";

export const rodoDocuments = [
  {
    id: "rodo",
    title: "RODO - klauzula informacyjna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/RODO-klauzula-1.pdf`
  },
  {
    id: "ukraina",
    title:
      "Klauzula informacyjna - przetwarzanie danych osobowych dla obywateli Ukrainy",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/doc04568720220315121249.pdf`
  },
  {
    id: "dziennik-elektroniczny",
    title:
      "Klauzula informacyjna dla rodziców/uczniów - dziennik elektroniczny",
    href: `${WORDPRESS_API}/wp-content/uploads/2020/03/klauzula-dla-uczniów-i-rodziców-pdf.pdf`
  },
  {
    id: "wycieczki",
    title: "Klauzula informacyjna - wycieczki",
    href: `${WORDPRESS_API}/wp-content/uploads/2020/02/KLAUZULA-WYCIECZKA.pdf`
  },
  {
    id: "monitoring",
    title: "Klauzula informacyjna - monitoring wizyjny",
    href: `${WORDPRESS_API}/wp-content/uploads/2020/02/KLAUZULA-MONITORING.pdf`
  },
  {
    id: "rekrutacja",
    title: "Klauzula informacyjna przy rekrutacji",
    href: `${WORDPRESS_API}/wp-content/uploads/2020/02/KLAUZULA-REKRUTACJA.pdf`
  },
  {
    id: "impreza",
    title: "Klauzula informacyjna dla uczestników imprezy",
    href: `${WORDPRESS_API}/wp-content/uploads/2020/02/KLAUZULA-IMPREZA.pdf`
  },
  {
    id: "iod",
    title: "Inspektor Ochrony Danych Osobowych",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Inspektor-Ochrony-Danych-Osobowych.pdf`
  }
];

export const rodoImage = "/assets/images/school-site/rodo/dziennik-elektroniczny-image.jpg";